import { createContext } from "react";

export interface FeatureFlagsContextValue {
  /**
   * Slice 9 Glofox integrator import (`api-portal-integrator-sync`, AES-358).
   * Fail-closed when LaunchDarkly is on.
   */
  integratorSyncEnabled: boolean;
  /**
   * Slice 11 live credential flow (`api-portal-live-credentials`, AES-387).
   * Fail-closed when LaunchDarkly is on.
   */
  liveCredentialsEnabled: boolean;
  /**
   * False while LaunchDarkly is still evaluating for the current identity.
   * The fail-closed values are indistinguishable from a real "off", so acting
   * on them early would send a remembered session to the legacy experience.
   */
  flagsResolved: boolean;
}

/**
 * Values shared with the Markdoc docs site.
 * `sandboxCredentialsEnabled` stays true so glofox-docs keeps the Slice 6 topnav.
 */
export type MirroredFeatureFlags = {
  sandboxCredentialsEnabled: boolean;
};

/**
 * Defaults when LaunchDarkly is not configured (local).
 * Slice 6, the ABC Developer Platform landing, and access-request contestation
 * are always on.
 * With LD enabled, evaluation overrides the remaining flags (fail-closed to false).
 */
export const defaultFeatureFlags: FeatureFlagsContextValue = {
  integratorSyncEnabled: true,
  liveCredentialsEnabled: true,
  flagsResolved: true,
};

export const FeatureFlagsContext =
  createContext<FeatureFlagsContextValue>(defaultFeatureFlags);
